// core.js: utilidades comuns do tema Clube Rock 2026 (módulo; ≤ 3 KB).
// - Folhas <dialog> (busca): [data-abre="id"] abre com showModal (foco preso, Esc fecha); [data-fecha] fecha;
//   clique fora do conteúdo fecha. O navegador devolve o foco ao elemento de origem.
// - Menu mobile: sem JS é um <details> com painel abaixo do cabeçalho. Aqui o conteúdo do painel passa para um
//   <dialog> (mesmos links, sem duplicar HTML) e o <summary> abre a folha. Se algo falhar, o <details> continua.
// - Rodapé: no celular (< 741 px) colunas em acordeão; no computador ficam abertas e o título não alterna.
// - Editor do tema: refaz menu e rodapé em shopify:section:load.
// - window.CR: espaço de nomes compartilhado (CR.cart no L4; CR.analytics é do Pedal).
const CR = (window.CR = window.CR || {});
document.documentElement.classList.add('cr-js'); // CSS que depende do JS (trava do rodapé no desktop) só vale com o módulo ativo

function abrir(dialog, origem) {
  if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return false;
  dialog.showModal();
  dialog.querySelector('input[type="search"]')?.focus();
  dialog.dispatchEvent(new CustomEvent('cr:folha:aberta', { bubbles: true, detail: { origem } }));
  return true;
}

function prepararMenu() {
  const det = document.querySelector('[data-menu]');
  if (!det || det.dataset.pronto || typeof HTMLDialogElement !== 'function') return;
  const painel = det.querySelector('[data-menu-painel]');
  const botao = det.querySelector('summary');
  if (!painel || !botao) return;
  document.getElementById('cr-menu')?.remove();
  const dlg = document.createElement('dialog');
  dlg.id = 'cr-menu';
  dlg.className = 'cr-folha cr-folha--esq';
  dlg.setAttribute('aria-label', painel.dataset.rotulo || 'Menu');
  dlg.append(...painel.childNodes);
  document.body.append(dlg);
  det.open = false;
  det.dataset.pronto = '1';
  botao.setAttribute('aria-haspopup', 'dialog');
  botao.setAttribute('aria-controls', 'cr-menu');
  botao.addEventListener('click', (e) => { e.preventDefault(); abrir(dlg, botao); });
}

// Um ouvinte de clique só (L10c: juntar os dois liberou bytes para o carregador do frete). Ordem: rodapé, promo e "+"
// (cliques independentes) e depois abrir/fechar folha.
const desktop = window.matchMedia('(min-width: 741px)');
document.addEventListener('click', (e) => {
  if (desktop.matches && e.target.closest('[data-rodape-col] > summary')) e.preventDefault();
  // Barra de anúncio (L7b; plano §2): clique no link vai ao dataLayer, mesmo antes do analytics.js carregar.
  // O envio ao GTM continua sob a trava da prévia (analytics-trava).
  const promo = e.target.closest('[data-cr-promo]');
  if (promo) (window.dataLayer ||= []).push({ event: 'select_promotion', promotion_name: promo.dataset.crPromo, creative_slot: promo.dataset.crSlot, link_url: promo.getAttribute('href') });
  // "+" do card (L7b; botão mínimo no L7e): assets/rapido.js, carregado no 1º toque pela URL versionada que a casca do
  // drawer traz (data-rapido-js; sem o ?v= a CDN servia a versão antiga). data-cr-add, não data-cr-mais (paginação do
  // Pedal) nem data-cr-rapido (card-rapido). O botão só aparece com este módulo (classe cr-js); sem carrinho pronto,
  // sem a casca ou se o módulo falhar, vai para o produto (link do card).
  const add = e.target.closest('[data-cr-add]');
  if (add && !e.defaultPrevented) {
    const ir = () => { location.href = add.closest('.cr-card').querySelector('a').href; };
    const url = document.getElementById('cr-carrinho')?.dataset.rapidoJs;
    if (!CR.cart || !url) ir();
    else import(url).then((m) => m.abrir(add)).catch(ir);
  }
  const abre = e.target.closest('[data-abre]');
  if (abre) {
    if (abrir(document.getElementById(abre.dataset.abre), abre)) e.preventDefault();
    return;
  }
  const fecha = e.target.closest('[data-fecha]');
  if (fecha) {
    const d = fecha.closest('dialog');
    if (d) d.close();
    return;
  }
  // clique no fundo (fora da caixa do conteúdo) fecha a folha
  if (e.target instanceof HTMLDialogElement && e.target.classList.contains('cr-folha')) {
    const r = e.target.getBoundingClientRect();
    const fora = e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
    if (fora) e.target.close();
  }
});

// Rodapé em acordeão
// Na carga só abre (desktop); fechar só na troca de largura, para não mexer no que o cliente abriu nem causar salto.
function ajustarRodape(troca) {
  for (const col of document.querySelectorAll('[data-rodape-col]')) {
    if (desktop.matches) col.open = true;
    else if (troca === true) col.open = false;
    const titulo = col.querySelector('summary');
    if (titulo) titulo.tabIndex = desktop.matches ? -1 : 0;
  }
}
desktop.addEventListener('change', () => ajustarRodape(true));

// Trio (F5/F6, spec-trio-progresso da Prisma): o cart.js troca o corpo do carrinho inteiro (HTML novo não transiciona).
// A cada cr:cart:html, a barra segmentada parte do n anterior e vai ao novo no quadro seguinte; quando o trio fecha
// (n anterior < k ≤ n novo) pela 1ª vez na sessão, o card ganha is-desbloqueado e o aviso TA-07 vai ao leitor de tela.
// n anterior: o da última barra vista, ou o da renderização da página (data-kit-n da casca do drawer ou da barra de /cart).
let nTrio = +document.querySelector('[data-kit-n]')?.dataset.kitN;
document.addEventListener('cr:cart:html', ({ detail }) => {
  const b = detail?.querySelector('[data-cr-trio]');
  const seg = b?.querySelector('.cr-trio-seg');
  const antes = nTrio;
  nTrio = +b?.dataset.kitN;
  if (!seg || !(antes >= 0) || antes === nTrio) return;
  const k = seg.children.length;
  const marca = (m) => { [...seg.children].forEach((s, i) => s.classList.toggle('is-on', i < m)); seg.classList.toggle('is-completo', m >= k); };
  marca(antes);
  void seg.offsetWidth; // estilo calculado no estado anterior: a troca seguinte transiciona
  marca(nTrio);
  try {
    if (antes < k && nTrio >= k && !sessionStorage.cr_trio_desbloqueado) {
      sessionStorage.cr_trio_desbloqueado = 1;
      b.classList.add('is-desbloqueado');
      const a = b.querySelector('[data-trio-aviso]');
      a.textContent = a.dataset.t;
    }
  } catch { /* sem sessionStorage: sem animação */ }
});

// L10c: calculadora de frete do drawer e de /cart (<details data-cr-frete>, snippets/frete-carrinho): o frete.js só
// carrega quando o cliente abre "Calcular frete", pela URL versionada do data-js (toggle não borbulha: captura).
// Só o <details> do frete tem data-js.
document.addEventListener('toggle', ({ target: d }) => {
  if (d.open && d.dataset?.js) import(d.dataset.js).then((m) => m.iniciar(d));
}, true);

function iniciar() {
  prepararMenu();
  ajustarRodape();
}
iniciar();
document.addEventListener('shopify:section:load', iniciar);

CR.abrirFolha = abrir;
